import React from "react";
import { Box, Typography } from "@mui/material";
import { getLeadStatusDefinition } from "../constants/leadStatuses";
import LeadStatusIcon from "./LeadStatusIcon";

export default function LeadStatusCell({ status }) {
  const def = getLeadStatusDefinition(status);

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <LeadStatusIcon status={status} size={20} />
      <Typography sx={{ ml: 1, fontSize: "0.85rem", color: "text.primary" }}>
        {status || def.value}
      </Typography>
    </Box>
  );
}
